import axios from 'axios'
import { ElMessage, ElMessageBox } from 'element-plus'

import { getToken } from '@/utils/auth'
//import setting from '@/utils/SettingInServer'

function get_base_url(){
  let baseUrl = location.protocol+'//' + location.hostname
  let portConfig //= await setting('API_PORT')
  if(!portConfig){
    portConfig = process.env.VUE_APP_API_PORT
  }
  
  let port = portConfig
  if(!port){
    port = location.port
  }
  if(port){
    baseUrl += ':' + port
  }
  return baseUrl    
}

const baseURL = get_base_url()
const options = {
  //vite 变量必须以VUE_APP_开头
  baseURL, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: process.env.VUE_APP_REQUEST_TIMEOUT||5000 // request timeout
}
// create an axios instance
const service = axios.create(options)
const requestStorePlugin = function(store) {
  // request interceptor
  service.interceptors.request.use(
    config => {
      // do something before request is sent

      if (store.getters.token) {
        // let each request carry token
        // ['X-Token'] is a custom headers key
        // please modify it according to the actual situation
        config.headers['X-Token'] = getToken()
      }
      return config
    },
    error => {
      // do something with request error
      console.log(error) // for debug
      return Promise.reject(error)
    }
  )

  // response interceptor
  service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
    */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
      const res = response.data

      // if the custom code is not 20000, it is judged as an error.
      if (res.code !== 20000) {
        ElMessage({
          message: res.message || 'Error',
          type: 'error',
          duration: 5 * 1000
        })

        // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
        if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
          // to re-login
          ElMessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
            confirmButtonText: 'Re-Login',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }).then(() => {
            store.dispatch('user/resetToken').then(() => {
              location.reload()
            })
          })
        }
        return Promise.reject(res.message || 'Error')
      } else {
        return res
      }
    },
    error => {
      console.log('err' + error) // for debug
      ElMessage({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(error)
    }
  )

}

export default service
export {requestStorePlugin}